import { handleValidationChange } from "./CommonValidation";

export const validateStore = (data, cigarArr, isIllicit, isQR, hasImage, isPosterPrio1, isPosterPrio2, isFlyer, isTradeLetter, setIsError) => {
    var isValid = true;

    var isValidEntry = true
    var isValidStore = true
    var isValidImage = true
    var isValidVisit = true
    var isValidPos1 = true
    var isValidIsPos1 = true
    var isValidPos2 = true
    var isValidIsPos2 = true
    var isValidFlyer = true
    var isValidIsFlyer = true
    var isValidTradeText = true
    var isValidIsTrade = true
    var isValidTradeReason = true
    var isValidTradeImg = true
    // var isValidReason = true
    var isValidIllicit = true
    var isValidQR = true
    var isValidHasImage = true
    var isValidReasonImage = true
    var isValidStreet = true
    var isValidBarangay = true
    var isValidCity = true

    // if(cigarArr.length === 0){
    //     handleValidationChange("entry", true, setIsError)
    //     isValidEntry = false
    // } else {
    //     handleValidationChange("entry", false, setIsError)
    //     isValidEntry = true
    // }

    if(data.store_name === "") {
        handleValidationChange("store_name", true, setIsError);
        isValidStore = false;
    } else {
        handleValidationChange("store_name", false, setIsError);
        isValidStore = true;
    }

    if(data.street_name === "") {
        handleValidationChange("street_name", true, setIsError);
        isValidStreet = false;
    } else {
        handleValidationChange("street_name", false, setIsError);
        isValidStreet = true;
    }
    if(data.barangay === "") {
        handleValidationChange("barangay", true, setIsError);
        isValidBarangay = false;
    } else {
        handleValidationChange("barangay", false, setIsError);
        isValidBarangay = true;
    }
    if(data.city === "") {
        handleValidationChange("city", true, setIsError);
        isValidCity = false;
    } else {
        handleValidationChange("city", false, setIsError);
        isValidCity = true;
    }

    if(hasImage === "") {
        handleValidationChange("has_image", true, setIsError);
        isValidHasImage = false;
    } else {
        handleValidationChange("has_image", false, setIsError);
        isValidHasImage = true;
        if(hasImage === "YES"){
            if(data.store_image === "") {
                handleValidationChange("store_image", true, setIsError);
                isValidImage = false;
            } else {
                handleValidationChange("store_image", false, setIsError);
                isValidImage = true;
            }
        }
        if(hasImage === "NO"){
            if(data.reason_image === "") {
                handleValidationChange("reason_image", true, setIsError);
                isValidReasonImage = false;
            } else {
                handleValidationChange("reason_image", false, setIsError);
                isValidReasonImage = true;
            }
        }
       
        
    }
    

    if(data.agent_visit === "" || data.agent_visit === "Pumili") {
        handleValidationChange("agent_visit", true, setIsError);
        isValidVisit = false;
    } else {
        handleValidationChange("agent_visit", false, setIsError);
        isValidVisit = true;
    }
    
    if(isPosterPrio1 === "") {
        handleValidationChange("is_poster_priority_1", true, setIsError);
        isValidIsPos1 = false;
    } else {
        handleValidationChange("is_poster_priority_1", false, setIsError);
        isValidIsPos1 = true;
        if(isPosterPrio1 === "NO"){
            if(data.poster_priority_1 === "") {
                handleValidationChange("poster_priority_1", true, setIsError);
                isValidPos1 = false;
            } else {
                handleValidationChange("poster_priority_1", false, setIsError);
                isValidPos1 = true;
            }
        }
     
    }

    if(isPosterPrio2 === "") {
        handleValidationChange("is_poster_priority_2", true, setIsError);
        isValidIsPos2 = false;
    } else {
        handleValidationChange("is_poster_priority_2", false, setIsError);
        isValidIsPos2 = true;
        if(isPosterPrio2 === "NO"){
            if(data.poster_priority_2 === "") {
                handleValidationChange("poster_priority_2", true, setIsError);
                isValidPos2 = false;
            } else {
                handleValidationChange("poster_priority_2", false, setIsError);
                isValidPos2 = true;
            }        
        }
    }

    if(isFlyer === "") {
        handleValidationChange("is_flyer", true, setIsError);
        isValidIsFlyer = false;
    } else {
        handleValidationChange("is_flyer", false, setIsError);
        isValidIsFlyer = true;
        if(isFlyer === "NO"){
            if(data.flyer === "") {
                handleValidationChange("flyer", true, setIsError);
                isValidFlyer = false;
            } else {
                handleValidationChange("flyer", false, setIsError);
                isValidFlyer = true;
            }   
        }
    }

    // if(isTradeLetter === "") {
    //     handleValidationChange("is_trade_letter", true, setIsError);
    //     isValidIsTrade = false;
    // } else {
    //     handleValidationChange("is_trade_letter", false, setIsError);
    //     isValidIsTrade = true;
    //     if(isTradeLetter === "NO"){
    //         if(data.trade_letter === "") {
    //             handleValidationChange("trade_letter_reason", true, setIsError);
    //             isValidTradeReason = false;
    //         } else {
    //             handleValidationChange("trade_letter_reason", false, setIsError);
    //             isValidTradeReason = true;
    //         }
    //     }
    //     if(isTradeLetter === "YES"){
    //         if(data.signature_image === "") {
    //             handleValidationChange("trade_letter_signature", true, setIsError);
    //             isValidTradeImg = false;
    //         } else {
    //             handleValidationChange("trade_letter_signature", false, setIsError);
    //             isValidTradeImg = true;
    //         }
    //     }
    // }

    if(data.trade_letter === "") {
        handleValidationChange("trade_letter_text", true, setIsError);
        isValidTradeText = false;
    } else {
        handleValidationChange("trade_letter_text", false, setIsError);
        isValidTradeText = true;
    }

    if(isIllicit === "") {
        handleValidationChange("is_illicit", true, setIsError);
        isValidIllicit = false;
    } else {
        handleValidationChange("is_illicit", false, setIsError);
        isValidIllicit = true;
    }

    if(isQR === "") {
        handleValidationChange("qr_code", true, setIsError);
        isValidQR = false;
    } else {
        handleValidationChange("qr_code", false, setIsError);
        isValidQR = true;
    }

    isValid = isValid && 
                isValidStore && isValidImage && isValidVisit &&
                isValidPos1 && isValidPos2 && isValidFlyer &&
                isValidIllicit && isValidQR &&
                isValidHasImage && isValidReasonImage && isValidCity &&
                isValidBarangay && isValidStreet && isValidIsPos1 &&
                isValidIsPos2 && isValidIsFlyer && isValidIsTrade &&
                isValidTradeReason && isValidTradeImg && isValidEntry &&
                isValidTradeText

    return isValid
  
}

export const validateCigarette = (data, setIsError) => {
    var isValid = true;

    var isValidBrandName = true
    var isValidPackPrice = true
    var isValidStickPrice = true
    var isValidSold = true



    if(data.brand_name === "") {
        handleValidationChange("brand_name", true, setIsError);
        isValidBrandName = false;
    } else {
        handleValidationChange("brand_name", false, setIsError);
        isValidBrandName = true;
    }

    if(data.pack_price === "" || parseFloat(data.pack_price) < 1) {
        handleValidationChange("pack_price", true, setIsError);
        isValidPackPrice = false;
    } else {
        handleValidationChange("pack_price", false, setIsError);
        isValidPackPrice = true;
    }

    if(data.stick_price === "" || parseFloat(data.stick_price) < 1) {
        handleValidationChange("stick_price", true, setIsError);
        isValidStickPrice = false;
    } else {
        handleValidationChange("stick_price", false, setIsError);
        isValidStickPrice = true;
    }

    if(data.weekly_sale === "") {
        handleValidationChange("weekly_sale", true, setIsError);
        isValidSold = false;
    } else {
        handleValidationChange("weekly_sale", false, setIsError);
        isValidSold = true;
    }


    isValid = isValid && 
                isValidBrandName && isValidPackPrice &&
                isValidStickPrice && isValidSold

    return isValid
  
}